<template>
  <div>
    <div class="text-center mb-0 d-flex justify-content-center
              text-neutral button-save-filter text-neutral">
      <span
        v-if="!selectedFilter"
        class="pointer px-2 d-flex align-content-center"
        @click="openSaveFilterModal()" >
        <img
          class="report-form__show-custom-save-report__icon mr-2"
          src="@/assets/save-filter.svg"
          alt="#"
          >
        Salvar novo filtro
      </span>
      <span
        v-else
        class="pointer px-2 d-flex align-content-center"
        @click="openUpdateFilterModal()">
        <img
          class="report-form__show-custom-save-report__icon mr-2"
          src="@/assets/save-filter.svg"
          alt="#"
          >
        Alterar o filtro salvo
      </span>
    </div>

    <b-modal id="modal" ref="modal" :title="modalTitle" :hide-header="!modalTitle"
      :hide-footer="true">
      <div v-if="loading" class="d-flex justify-content-center align-items-center">
        <img src="@/assets/images/loader.svg" alt="Carregando..." class="mr-2">
        <span>Salvando filtro {{filterName}}</span>
      </div>

      <div v-else-if="success" class="d-flex justify-content-center align-items-center">
        <img src="@/assets/success.svg" alt="Sucesso" class="mr-2">
        <span>Filtro salvo com sucesso</span>
      </div>

      <div v-else>
        <p class="filter-name-title">Nome do filtro</p>
        <b-form-input class="filter-name" v-model="filterName" placeholder="nome filtro"
          :disabled="DisplayError">
        </b-form-input>
        <b-form-invalid-feedback v-if="DisplayError" class="d-block" v-html="msg" />
        <b-button
          :disabled="DisplayError"
          variant="orange"
          class="btn btn-block mt-2"
          @click="persist">
          <img src="@/assets/save-filter-white.svg" alt="#"
            class="report-form__show-custom-save-report__icon"> Salvar filtro
        </b-button>
      </div>
    </b-modal>
  </div>

</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import SavedFiltersApi from '@/services/savedFilters';

export default {
  name: 'ButtonSaveFilter',
  data() {
    return {
      filterName: '',
      selectedValues: '',
      msg: '',
      DisplayError: false,
      hideHeader: true,
      hideFooter: true,
      loading: false,
      success: false,
    };
  },
  computed: {
    ...mapGetters(['selectedFilter']),
    modalTitle() {
      return !this.loading && !this.success ? 'Salvar filtro' : '';
    },
  },
  props: ['value', 'options', 'validation'],
  methods: {
    ...mapActions(['fetchFilters', 'selectFilter']),
    validate() {
      return typeof this.validation === 'function' ? this.validation() : true;
    },
    async sendUpdatedFilterList() {
      await this.fetchFilters();
      this.filterName = '';
      this.success = true;
      setTimeout(() => this.$refs.modal.hide(), 1000);
    },
    async saveFilter() {
      this.loading = true;
      this.setError('');

      if (this.filterName === '') {
        this.setError('Um nome para o filtro deve ser digitado');
      }

      // Verifica se o nome digitado é igual a de algum filtro já salvo
      this.value.forEach((savedReport) => {
        if (savedReport.description === this.filterName && this.filterName.length > 0) {
          this.setError('Nome do filtro inválido. <strong>Já existe um filtro salvo com o nome informado.</strong>');
        }
      });

      if (!this.DisplayError) {
        const saveFilter = await SavedFiltersApi.saveFilter(this.options, this.filterName);

        if (saveFilter.ajaxStatus === '1') {
          await this.sendUpdatedFilterList();
        }
      }

      this.loading = false;
    },
    async updateFilter() {
      this.loading = true;

      const updateFilter = await SavedFiltersApi.updateFilter(
        {
          ...this.options,
          name: this.filterName,
        },
        this.selectedFilter.idtUserSupplierReport,
      );

      if (updateFilter.ajaxStatus === '1') {
        await this.sendUpdatedFilterList();
      }

      this.loading = false;
    },
    openUpdateFilterModal() {
      this.$emit('updateFilter');
      this.filterName = this.selectedFilter.desUserSupplierReport;
      this.openModal();
    },
    openSaveFilterModal() {
      this.$emit('saveFilter');
      this.filterName = '';
      this.openModal();
    },
    openModal() {
      if (!this.validate()) return false;
      this.loading = false;
      this.success = false;
      return this.$refs.modal.show();
    },
    setError(description) {
      this.DisplayError = !!description;
      this.msg = description;
    },
    async persist() {
      if (this.selectedFilter) {
        await this.updateFilter();
      }
      await this.saveFilter();
    },
  },
};
</script>
<style lang="scss" scoped>
.filter-name-title{font-family: $font-1;}

.filter-name {
  border: 1px solid #707070;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  border-radius: 0;
}

.text-filter-saved{font-weight: bold;}
</style>
